import { useQuery } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { CONVERSATION_CACHE_TIME, CONVERSATION_STALE_TIME } from '@web/conversations/consts/cache';
import { getConversationsQueryKey } from '@web/conversations/utils/getQueryKey';
import { mapAPIConversations } from '@web/conversations/utils/mappers';

export const useGetConversations = () => {
  const { conversation } = useSlingApi();

  const queryKey = getConversationsQueryKey();

  const result = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await conversation.getAll();
      const conversations = mapAPIConversations(data);

      return conversations;
    },

    cacheTime: CONVERSATION_CACHE_TIME,
    staleTime: CONVERSATION_STALE_TIME,
  });

  return result;
};
